import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import user from './modules/user'
import users from './modules/users'
import logs from './modules/logs'
import stats from './modules/stats'
import comments from './modules/comments'
import welcomedialog from './modules/welcome_dialog'
import settings from './modules/settings'

import guidelines from './modules/guidelines'
import guideline_user_role from './modules/guideline_user_role'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: {},

  getters: {},

  modules: {
    auth,
    user,
    users,
    logs,
    stats,
    guidelines,
    guideline_user_role,
    comments,
    welcomedialog,
    settings
  },
  strict: debug,
  // plugins: debug ? [createLogger()] : []
})